import React, { useRef, useEffect } from "react"
import Cta from "../components/cta"
import tweetData from "../data/tweets.json"
import { getRandom } from "../helpers/arrays"

export default function SiteFooterTwitter({ path }) {
  const tweets = tweetData.filter(obj => {
    return obj.path === path
  })

  const tweet = tweets.length >= 1 ? getRandom(tweets) : getRandom(tweetData)

  const contentRef = useRef()

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.innerHTML = urlify(tweet.content)
    }
  }, [contentRef])

  function urlify(text) {
    const urlRegex = /(https?:\/\/[^\s]+)/g
    let link = text.replace(urlRegex, function (url) {
      return (
        '<a href="' +
        url.replace(/\.$/, "") +
        '">' +
        url.replace(/\.$/, "") +
        "</a>"
      )
    })

    const hashRegex = /(^|\s)(#[a-z\d-]+)/gi
    link = link.replace(hashRegex, function (hash) {
      return (
        '<a href="https://twitter.com/hashtag/' +
        hash.replace("#", "").trim() +
        '">' +
        hash +
        "</a>"
      )
    })
    return link
  }

  return (
    <li className="site-footer__twitter">
      <header>
        <h3 className="title--m">Twitter Highlights</h3>
        <div className="title--xs">
          <a href={`https://twitter.com/${tweet.account}`}>
            @{tweet.account}
            <span className="site-footer__twitter__date">{tweet.date}</span>
          </a>
        </div>
      </header>
      <p ref={contentRef} />
      <Cta type="secondary" href={tweet.url} text="Follow Us" />
    </li>
  )
}
